export default __webpack_public_path__ + "static/media/DRIVERLICENSEDOCTORCERTIFICATE_EN_BLANK.434f52c7.png";